import React from 'react';
import Banner from '../CommonComponents/Banner';
import HotelList from '../HotelComponents/HotelList';
import WhyChooseUs from '../CommonComponents/WhyChooseUs';
import FallsviewCasino from "../assets/images/best-casino-hotels.jpg";
import CasinoMontreal from "../assets/images/top-casino-hotels.jpg";
import TopRated from "../assets/images/top-rated-casino-hotels.jpg";
import Guide from "../assets/images/casino-hotels-guide.jpg";
import User from "../assets/images/user-selected-casino-hotels.jpg";
import Header from '../LayoutComponents/Header';
import Footer from '../LayoutComponents/Footer';

const CasinoHotels = () => {
  const casinoHotels = [
    {
      name: "Fallsview Casino Resort *Best Casino Hotels",
      image: FallsviewCasino,
      location: "Niagara Falls, Ontario",
      overview: <>Fallsview Casino Resort offers an exquisite combination of <strong>luxury</strong> and excitement, located near the stunning Niagara Falls. This <strong>top-rated resort</strong> is ideal for those seeking both relaxation and vibrant entertainment.</>,
      rooms: <>Enjoy <strong>elegant</strong> rooms with floor-to-ceiling windows and breathtaking views of the falls. Premium amenities include flat-screen TVs, high-speed internet, and whirlpool tubs.</>,
      dining: "Indulge in gourmet dining at elegant restaurants and enjoy casual bites at cozy lounges.",
      facilities: "Explore a state-of-the-art casino, relax at a serene spa, or enjoy live performances at the theater.",
      service: "Exceptional staff provide seamless service, ensuring a perfect stay from check-in to check-out.",
      experience: <>With its <strong>luxurious</strong> amenities and exciting entertainment options, Fallsview Casino Resort is a <strong>selected</strong> destination for a memorable getaway.</>
    },
    {
      name: "Casino de Montréal Hotel *Top Casino Hotels",
      image: CasinoMontreal,
      location: "Montreal, Quebec",
      overview: <>Situated in the heart of Montreal, the <strong>best</strong> casino hotel in the city, Casino de Montréal, offers a sophisticated blend of luxury and entertainment. Ideal for both business and leisure travelers.</>,
      rooms: "The rooms feature stunning city views, modern amenities, high-speed internet, and flat-screen TVs.",
      dining: <>Savor gourmet meals in <strong>upscale</strong> restaurants, relax in casual dining spaces, or enjoy cocktails in stylish lounges.</>,
      facilities: "The hotel offers a dynamic casino, a luxurious spa, fitness centers, and versatile event spaces for a wide range of activities.",
      service: "Enjoy impeccable service from a friendly and professional team.",
      experience: <>This <strong>top-rated</strong> hotel perfectly blends elegance with vibrant entertainment, making it a prime choice for your next stay in Montreal.</>
    },
    {
      name: "River Rock Casino Resort *Top-Rated Casino Hotels",
      image: TopRated,
      location: "Richmond, British Columbia",
      overview: <>River Rock Casino Resort offers a <strong>luxurious</strong> escape with breathtaking views and a blend of entertainment and relaxation, just a short distance from Vancouver.</>,
      rooms: "Elegant rooms equipped with premium amenities, including flat-screen TVs, high-speed internet, and plush bedding.",
      dining: "Enjoy an array of dining options ranging from fine dining to casual eateries, plus vibrant lounges for cocktails.",
      facilities: "Featuring a full-service spa, outdoor pool, fitness center, and a lively casino, this resort ensures both excitement and relaxation.",
      service: "Friendly and professional staff ensure an exceptional guest experience.",
      experience: <>Whether you seek <strong>luxury</strong> or adventure, River Rock Casino Resort offers the best of both worlds in a tranquil setting.</>
    },
    {
      name: "Shawnee Inn and Golf Resort *User Selected Casino Hotels",
      image: User,
      location: "Shawnee on Delaware, Pennsylvania",
      overview: "Shawnee Inn and Golf Resort offers a serene getaway amidst the scenic Pocono Mountains. Perfect for those looking to balance luxury with recreation.",
      rooms: "Rooms feature stylish décor, high-speed internet, and flat-screen TVs, with views of the mountains or river.",
      dining: <>From <strong>gourmet</strong> dining to casual options, there's something for every taste.</>,
      facilities: "The resort offers a championship golf course, a spa, a fitness center, and plenty of recreational activities.",
      service: <>The dedicated team ensures a seamless stay, delivering <strong>top-notch</strong> service throughout.</>,
      experience: <>A <strong>selected</strong> choice for luxury and outdoor adventure, Shawnee Inn and Golf Resort is perfect for a <strong>top-rated</strong> retreat.</>
    },
    {
      name: "Gateway Casino & Entertainment",
      image: Guide,
      location: "Various locations across New Zealand",
      overview: <>Gateway Casino & Entertainment offers a selection of properties across New Zealand, combining <strong>luxury</strong> accommodations with dynamic entertainment options.</>,
      rooms: "Rooms are designed for comfort, featuring modern amenities such as flat-screen TVs, high-speed internet, and plush bedding.",
      dining: "Enjoy a variety of dining options, from gourmet restaurants to lively bars, perfect for any occasion.",
      facilities: "Properties feature spas, fitness centers, and entertainment activities, ensuring a diverse experience for all guests.",
      service: <>Dedicated staff provide <strong>exceptional</strong> service at every location.</>,
      experience: <>Gateway Casino & Entertainment offers a <strong>luxurious</strong> and thrilling experience in New Zealand, making it one of the <strong>top picks</strong> for travelers seeking both comfort and excitement.</>
    }
  ];

  return (
    <>
      <Header />
      <Banner 
        title="Discover New Zealand's <span>Top Offline Casino Hotels</span>"
        description="Experience the best **offline casino resorts** in New Zealand, where luxury meets **premium gambling experiences**. Our handpicked selection features the finest accommodations, world-class **offline gaming**, and exclusive VIP casino lounges. Whether you're looking for a high-stakes table game or a relaxing getaway, these top picks offer an unforgettable **offline gambling experience**."
      />
      
      <HotelList hotels={casinoHotels} />
      
      <WhyChooseUs
        title={<span><span>Why Choose Us</span> for the <strong>Best Offline Casino Hotels</strong> in New Zealand</span>}
        sections={[
          {
            title: "<strong>Trusted Reviews</strong> for Exclusive Casino Hotels:",
            content: "Our team personally evaluates every **offline casino resort**, ensuring **high-quality gaming experiences** and **exceptional hospitality**. We provide **reliable recommendations** based on genuine experiences."
          },
          {
            title: "<strong>Authentic Offline Casino Experiences:</strong>",
            content: "We only feature **legally operated, offline gambling destinations** in New Zealand. No online gambling services are included in our recommendations."
          }
        ]}
      />
      
      {/* Responsible Gaming Section */}
      <div className="container mb-4">
        <div className="row">
          <div className="col-12">
            <div className="responsible-gaming-section p-4 bg-light rounded">
              <div className="mt-3 text-center">
                <p className="mb-0 small">
                  <strong>Legal Disclaimer:</strong> All gambling services mentioned on this website are strictly **offline** and comply with Norwegian gambling laws. **Online gambling services are not offered.** Please gamble responsibly.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </>
  );
};

export default CasinoHotels;